// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Georama/Georama-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Georama/Georama-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Georama/Georama-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Georama/Georama-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/Georama/Georama-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Georama/Georama-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/Georama/Georama-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./fonts/Georama/Georama-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./fonts/Georama/Georama-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./fonts/Inter/Inter-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./fonts/Inter/Inter-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./fonts/Inter/Inter-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./fonts/Inter/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./fonts/Inter/Inter-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./fonts/Inter/Inter-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./fonts/Inter/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./fonts/Inter/Inter-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./fonts/Inter/Inter-Black.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Georama";
  font-style: normal;
  font-weight: 100;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Georama";
  font-style: normal;
  font-weight: 200;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Georama";
  font-style: normal;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "Georama";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "Georama";
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: "Georama";
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: "Georama";
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: "Georama";
  font-style: normal;
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "Georama";
  font-style: normal;
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 100;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 200;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("truetype");
}
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("truetype");
}
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
}
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("truetype");
}
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype");
}
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("truetype");
}`, "",{"version":3,"sources":["webpack://./src/fonts.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AACF;AAEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AAAF;AAGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AADF;AAIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AAFF;AAKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AAHF;AAKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AAHF;AAMA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AAJF;AAOA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AALF;AAQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AANF;AAUA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AARF;AAWA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gEAAA;AATF;AAWA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gEAAA;AATF;AAYA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gEAAA;AAVF;AAaA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gEAAA;AAXF;AAcA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gEAAA;AAZF;AAcA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gEAAA;AAZF;AAeA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gEAAA;AAbF;AAeA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gEAAA;AAbF","sourcesContent":["@font-face {\n  font-family: 'Georama';\n  font-style: normal;\n  font-weight: 100;\n  src: url('/fonts/Georama/Georama-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Georama';\n  font-style: normal;\n  font-weight: 200;\n  src: url('/fonts/Georama/Georama-ExtraLight.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Georama';\n  font-style: normal;\n  font-weight: 300;\n  src: url('/fonts/Georama/Georama-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Georama';\n  font-style: normal;\n  font-weight: 400;\n  src: url('/fonts/Georama/Georama-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Georama';\n  font-style: normal;\n  font-weight: 500;\n  src: url('/fonts/Georama/Georama-Medium.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Georama';\n  font-style: normal;\n  font-weight: 600;\n  src: url('/fonts/Georama/Georama-SemiBold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Georama';\n  font-style: normal;\n  font-weight: 700;\n  src: url('/fonts/Georama/Georama-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Georama';\n  font-style: normal;\n  font-weight: 800;\n  src: url('/fonts/Georama/Georama-ExtraBold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Georama';\n  font-style: normal;\n  font-weight: 900;\n  src: url('/fonts/Georama/Georama-Black.ttf') format('truetype');\n}\n\n\n@font-face {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 100;\n  src: url('/fonts/Inter/Inter-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 200;\n  src: url('/fonts/Inter/Inter-ExtraLight.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 300;\n  src: url('/fonts/Inter/Inter-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  src: url('/fonts/Inter/Inter-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  src: url('/fonts/Inter/Inter-Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  src: url('/fonts/Inter/Inter-SemiBold.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  src: url('/fonts/Inter/Inter-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 800;\n  src: url('/fonts/Inter/Inter-ExtraBold.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 900;\n  src: url('/fonts/Inter/Inter-Black.ttf') format('truetype');\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
